import * as React from 'react'
import PropTypes from 'prop-types'
import { PopoverClose } from '../../../internal/components/PopoverClose'
import { useThemeStyles } from '../../../theming'
import type { ButtonOnClickHandler } from '../../../types'
import styles from './styles'

export interface ModalCloseProps {
  /**
   * Indicates the close button is sitting on a dark background.
   */
  dark?: boolean
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  /**
   * The function to call when a 'click' event is fired.
   */
  onClick?: ButtonOnClickHandler
}

export function ModalClose({ dark = false, ...restProps }: ModalCloseProps) {
  const sx = useThemeStyles(styles, { dark })
  return (
    <div css={sx.wrap}>
      <PopoverClose {...restProps} dark={dark} />
    </div>
  )
}

ModalClose.propTypes = {
  dark: PropTypes.bool,
  'data-.*': PropTypes.string,
  onClick: PropTypes.func,
}

ModalClose.displayName = 'Modal.Close'
